import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, Observable, of } from 'rxjs';
import * as cultureAction from '../actions/cultures.actions';
import { catchError, map } from 'rxjs/operators';
import { SiteContextGatewayService } from '../../site-context/gateway/site-context.gateway';

@Injectable({
  providedIn: 'any',
})
export class CulturesEffect {
  private actions$ = inject(Actions);
  private siteContextGatewayService = inject(SiteContextGatewayService);

  loadCultures$: Observable<
    cultureAction.LoadCulturesSuccess | cultureAction.LoadCulturesFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(cultureAction.LOAD_CULTURES),
      exhaustMap(() =>
        this.siteContextGatewayService.getBaseSites('DEFAULT').pipe(
          map((response) => {
            return new cultureAction.LoadCulturesSuccess(response);
          }),
          catchError((error: Error) =>
            of(new cultureAction.LoadCulturesFail(error)),
          ),
        ),
      ),
    ),
  );
}
